import { Box, Button, HStack, VStack } from '@chakra-ui/react'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { REPOSITORY } from '../../../../api/repository/Repository'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../../../utils/hooks/Context/RequestStatusContext'
import PartnersListReport from './PartnersListReport'

export default function partnersList() {
  const [data, setData] = useState(null)
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()
  const handleGetNNData = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .listadoColaboradoresReporte()
      .then((res) => {
        setData(res.data.DatosSocios)
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle(error.response.data.error, error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
    handleCLoseLoading()
  }

  const handleGetReport = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .listadoColaboradoresExport()
      .then((res) => {
        handleCLoseLoading()
        const url = URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Partners_list.xlsx`)
        document.body.appendChild(link)
        link.click()
        handleSetTitle('Reporte descargado con exito', 200)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            Continuar
          </Button>,
        )
        handleOpen()
        handleCLoseLoading()
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle('No se pudo exportar el reporte.', error.response.status)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
  }

  return (
    <VStack alignItems="flex-start">
      <HStack alignItems="flex-end">
        <Button borderRadius={10} onClick={handleGetNNData}>
          Buscar
        </Button>
      </HStack>
      {data && (
        <HStack alignItems="flex-end" paddingTop={10} paddingBottom={5}>
          <PartnersListReport data={data} />
          <VStack paddingStart={5}>
            <Button
              borderRadius={8}
              variant="ghost"
              minHeight="56px"
              padding="0px 15px"
              backgroundColor="#fff"
              onClick={handleGetReport}
              border="1px solid #D7D7D7"
            >
              <Box me={3}>
                <FontAwesomeIcon icon={faDownload} />
              </Box>
              Descargar informe
            </Button>
          </VStack>
        </HStack>
      )}
    </VStack>
  )
}
